import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * The class merge every component builds its `className` with. It knows the
 * library's own motion scale (`index.css`): `duration-fast|base|slow|slower`
 * and `ease-spring|emphasized` are not values tailwind-merge ships, so
 * without this entry a caller's `duration-0` never displaces a variant's
 * `duration-slow` — both classes survive and the stylesheet's order, not the
 * call site's, decides the transition.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      duration: [{ duration: ["fast", "base", "slow", "slower"] }],
      ease: [{ ease: ["spring", "emphasized"] }],
    },
  },
});

/** A CSS attribute-selector value for an id. */
export function cssEscape(value: string): string {
  return CSS.escape(value);
}

/** `value` held inside `[min, max]`. */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
